import { NbUser } from '@nebular/auth';

export class CustomNbUser extends NbUser {
  constructor() {
    super();
  }
  public token?: string;
  public roleId?: number;
}
